<script setup lang="ts">
const props = defineProps<{
	hasOr?: boolean;
	isVertical?: boolean;
}>();
</script>

<template>
	<span
		class="divider"
		:class="[{
			'divider--is-line': !props.hasOr,
			'divider--vertical': props.isVertical,
		}]"
	>
		<span v-if="props.hasOr">or</span>
	</span>
</template>
